module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ab112-b0e9df6167ca2bf7207475d1158cb063.jpg";